import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const MyApiFilters = ({
  configOptions,
  modelOptions,
  actionOptions,
  filters,
  onFilterChange,
  onClear
}) => {
  const { t } = useTranslation("common");

  return (
    <div className="filter-bar">
      <select
        className="form-control filter-select filter-select-config"
        value={filters.config}
        onChange={(e) => onFilterChange("config", e.target.value)}>
        <option value="">{t("Config")}</option>
        {configOptions.map(([value, label]) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </select>
      <select
        className="form-control filter-select filter-select-model"
        value={filters.model}
        onChange={(e) => onFilterChange("model", e.target.value)}>
        <option value="">{t("Model")}</option>
        {modelOptions.map(([value, label]) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </select>
      <select
        className="form-control filter-select filter-select-action"
        value={filters.action}
        onChange={(e) => onFilterChange("action", e.target.value)}>
        <option value="">{t("Action")}</option>
        {actionOptions.map(([value, label]) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </select>
      <div className="search-wrap">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
        <input
          type="text"
          className="form-control"
          value={filters.search}
          onChange={(e) => onFilterChange("search", e.target.value)}
          placeholder={t("Search APIs…")}
        />
      </div>
      <button type="button" className="btn btn-ghost btn-sm" onClick={onClear}>
        {t("Clear")}
      </button>
    </div>
  );
};

MyApiFilters.propTypes = {
  configOptions: PropTypes.arrayOf(PropTypes.array).isRequired,
  modelOptions: PropTypes.arrayOf(PropTypes.array).isRequired,
  actionOptions: PropTypes.arrayOf(PropTypes.array).isRequired,
  filters: PropTypes.object.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired
};

export default MyApiFilters;
